export enum SentimentPercentileRangeEnum {
	NEGATIVE = '1,2',
	NEUTRAL = '3',
	POSITIVE = '4,5'
}